  <div>
    <div class="modal-header d-block p-0">
      <div class="px-3 pt-3">
        <div class="row">
          <div class="col-6 styled-select"> 
            <p class="heading-4"><span class="color-grey-700">Certificate</span></p>
          </div>
          <div class="col-6 text-right">
            <span class="cursor-pointer" (click)="goback()">
              <img src="assets/themes/icons/cancel.svg" alt="close" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <img
          *ngIf="finished == true"
          class="text-center"
          src="assets/themes/images/primary-loader.gif" alt="loader"
          width="40px"
          height="40px"
          id="loadmore_post"/>
      </div>
      <div>
        <div *ngFor="let daysList of certificateList">
          <p class="paragraph-bold pb-3">
            {{ daysList?.parent_name }}
          </p> 
          <div class="clearfix pb-2 pt-2 position-relative b-radius cursor-pointer brder mb-3 p-3 "
            *ngFor="let sessionCard of daysList?.session_list"
            (click)="eventcertificate(sessionCard?.program_id)">
            <div class="float-left calc-95">
              <p class="mb-2 secondary-paragraph ">{{ sessionCard?.program_name }}</p>
              <p class="secondary-paragraph mb-2">
                <span>{{ sessionCard?.event_vault_list?.tag_name }}</span>
                <span class="primary-small">
                  {{ sessionCard?.event_vault_list?.date_of_submission | date}}
                </span>
              </p>
              <p *ngIf="action == ''">
                <span *ngIf="sessionCard?.event_vault_list?.score != ''"
                  class=" chip small outline info icon-position-left ">
                  <img src="assets/themes/icons/cme-points.svg" alt="cme" width="15px"/>
                  {{ sessionCard?.event_vault_list?.score }}
                  {{ sessionCard?.event_vault_list?.point_name }}
                </span>
                <span class="pl-2 pr-2 pt-1 pb-1 text-white primary-small"
                  *ngIf="sessionCard?.tag_name != ''"
                  [ngStyle]="{'background-color': sessionCard?.tag_color_code }">
                 {{ sessionCard?.tag_name }}
                </span>
              </p>
            </div>
           <img class="float-right pt-4" src="assets/themes/icons/right-arrow.svg" alt="right-arrow" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-event-view-certificate  
    *ngIf="vaultObj != null && vaultObj != undefined && isSkpModalShown == true" (resetSkpModal)="resetSkpModal($event)"
    [vaultObj]="vaultObj"></app-event-view-certificate>